<template lang='pug'>
  .modal.fade.location-info-popup(v-if='showWelcomeMat' ref='welcomeMat' aria-hidden='true' tabindex='-1' role='dialog' data-show='true')
    .modal-dialog
      .modal-content
        .location-info-modal-stripes
        .modal-header
          button.close.close-location-info(type='button' data-dismiss='modal' aria-label='Close')
        .modal-body
          .page-title
            p.location-info-welcome(v-t='"popup.welcomeTo"')
            span(v-t='companyLocaleText')
          h2.location-info-brief
            p(v-t='"popup.exploreBeauty"')
            p(v-t='"popup.mostDesired"')

          template(v-if='countrySpecificText.minFreeShipping.includes(i18nSiteCountryLs)')
            .location-info-promotions(v-t='{ path: "locationSpecific.freeShippingWithAmount", args: { amount: freeShippingAmount }}')
            .location-info-promotions(v-t='"payments.paymentTypes.cod"')
          template(v-else)
            .location-info-promotions(v-t='"locationSpecific.freeShipping"')

          template(v-if='countrySpecificText.exclusive.includes(i18nSiteCountryLs)')
            .location-info-promotions(v-t='"locationSpecific.exclusive"')
          template(v-else)
            .location-info-promotions(v-t='"locationSpecific.onlineExclusive"')

          template(v-if='countrySpecificText.freeSamples.includes(i18nSiteCountryLs)')
            .location-info-promotions(v-t='"locationSpecific.freeSamples"')
          template(v-else)
            .location-info-promotions(v-t='"locationSpecific.freeSample"')

          template(v-if='showGDPR')
            .location-info-not-shipping-europe
              p(v-t='"locationSpecific.notShipping"')
              router-link.location-info-redirect-link(:to='{ name: "international" }' v-t='"buttons.clickHere"' data-dismiss='modal')
              span.location-find-store(v-t='"locationSpecific.findAStore"')
            button.btn.location-info-continue-browsing(data-dismiss='modal' v-t='"buttons.continueBrowsing"')

          template(v-else)
            button.btn.btn-primary.location-info-start-shopping(data-dismiss='modal' v-t='"buttons.startShopping"')
            .location-info-not-shipping
              span(v-t='{ path: "locationSpecific.notShippingWithCountry", args: { country: webCountry } }')
              span(v-t='"locationSpecific.takeMeTo"')
              a.location-info-redirect-link(:href='`https://${$t("domain", countryCode)}`' v-t='{ path: "locationSpecific.site", args: { country: userCountry } }' tabIndex='-1')

        .location-info-modal-stripes.bottom-stripe
</template>

<i18n>
{
  "lng_en": {
    "popup": {
      "welcomeTo": "Welcome to",
      "exploreBeauty": "Explore endless beauty from",
      "mostDesired": "the world's most desired beauty brands"
    },
    "locationSpecific": {
      "freeShipping": "Free Shipping with minimum spend",
      "freeShippingWithAmount": "Free Shipping with minimum spend of %{amount}",
      "exclusive": "Exclusive Brands & Specials",
      "onlineExclusive": "Online Exclusive Brands & Specials",
      "freeSample": "Free sample with every purchase",
      "freeSamples": "Samples with every purchase",
      "notShipping": "This site doesn't ship to your country.",
      "notShippingWithCountry": "Not shipping to %{country}?",
      "takeMeTo": "Take me to the",
      "findAStore": "to find a Sephora online store that ships to your doorstep.",
      "site": "%{country} site"
    },
    "buttons": {
      "startShopping": "Start Shopping",
      "continueBrowsing": "Continue Browsing",
      "clickHere": "Click here"
    }
  },
  "lng_id": {
    "popup": {
      "welcomeTo": "Welcome to",
      "exploreBeauty": "Explore endless beauty from",
      "mostDesired": "the world's most desired beauty brands"
    },
    "locationSpecific": {
      "freeShipping": "Free Shipping with minimum spend",
      "freeShippingWithAmount": "Free Shipping with minimum spend of %{amount}",
      "exclusive": "Exclusive Brands & Specials",
      "onlineExclusive": "Online Exclusive Brands & Specials",
      "freeSample": "Free sample with every purchase",
      "freeSamples": "Samples with every purchase",
      "notShipping": "This site doesn't ship to your country.",
      "notShippingWithCountry": "Not shipping to %{country}?",
      "takeMeTo": "Take me to the",
      "findAStore": "to find a Sephora online store that ships to your doorstep.",
      "site": "%{country} site"
    },
    "buttons": {
      "startShopping": "Start Shopping",
      "continueBrowsing": "Continue Browsing",
      "clickHere": "Click here"
    }
  },
  "lng_th": {
    "popup": {
      "welcome_to": "Welcome to",
      "exploreBeauty": "ค้นพบบิวตี้ไอเทมแบรนด์ดังมากมายจาก",
      "mostDesired": "ทั่วทุกมุมโลก"
    },
    "locationSpecific": {
      "freeShipping": "รับบริการจัดส่งฟรี",
      "freeShippingWithAmount": "Free Shipping with minimum spend of %{amount}",
      "exclusive": "โปรโมชั่นพิเศษจากแบรนด์ดัง",
      "onlineExclusive": "โปรโมชั่นพิเศษเมื่อช็อปออนไลน์",
      "freeSample": "Samples with every purchase",
      "freeSamples": "สินค้า Sample ฟรีทุกการสั่งซื้อ",
      "notShipping": "This site doesn't ship to your country.",
      "notShippingWithCountry": "ไม่ได้จัดส่งไปที่ %{country}?",
      "takeMeTo": "พาฉันไปที่",
      "findAStore": "to find a Sephora online store that ships to your doorstep.",
      "site": "เว็บไซต์ %{country}"
    },
    "buttons": {
      "startShopping": "เริ่มช็อปปิ้ง",
      "continueBrowsing": "Continue Browsing",
      "clickHere": "Click here"
    }
  },
  "lng_zh": {
    "popup": {
      "welcomeTo": "歡迎來到",
      "exploreBeauty": "探索世界各地",
      "mostDesired": "的美妝品牌"
    },
    "locationSpecific": {
      "freeShipping": "購物滿指定金額即享免費送貨",
      "freeShippingWithAmount": "購物滿%{amount}即享免費送貨",
      "exclusive": "獨家品牌及推廣",
      "onlineExclusive": "網上獨家品牌及推廣",
      "freeSample": "每次購物可獲免費試用品",
      "freeSamples": "每次購物均可獲免費試用品",
      "notShipping": "This site doesn't ship to your country.",
      "notShippingWithCountry": "並非運送至%{country}？",
      "takeMeTo": "帶我到",
      "findAStore": "to find a Sephora online store that ships to your doorstep.",
      "site": "%{country}網站"
    },
    "buttons": {
      "startShopping": "開始購物",
      "continueBrowsing": "Continue Browsing",
      "clickHere": "Click here"
    }
  },
  "lng_ko": {
    "popup": {
      "welcomeTo": "환영합니다",
      "exploreBeauty": "세상에서 가장 매력적인 브랜드들의",
      "mostDesired": "무한한 아름다움을 발견해보세요"
    },
    "locationSpecific": {
      "freeShipping": "최소 구매 금액 이상 무료 배송",
      "freeShippingWithAmount": "%{amount} 이상 구매 시 무료 배송",
      "exclusive": "단독 브랜드 & 특별 상품",
      "onlineExclusive": "온라인 단독 브랜드 & 특별 상품",
      "freeSample": "모든 주문 건당 무료 샘플 증정",
      "freeSamples": "모든 주문 건당 샘플 증정",
      "notShipping": "해당 국가로는 배송되지 않습니다. ",
      "notShippingWithCountry": "%{country} 지역으로는 배송되지 않나요? ",
      "takeMeTo": "로/으로 데려다주세요",
      "findAStore": "고객님의 주소로 배송 가능한 세포라 온라인 스토어 찾기",
      "site": "%{country} 사이트"
    },
    "buttons": {
      "startShopping": "쇼핑 시작하기",
      "continueBrowsing": "계속 쇼핑하기",
      "clickHere": "여기를 클릭하세요"
    }
  }
}
</i18n>

<script>
import { humanizePrice } from '@/modules/services/price-support'
import { saveToSession, getFromSession } from '@/modules/services/session-storage'
import { europeanUnion } from '@/modules/config/countries'

export default {
  computed: {
    i18nSiteCountryLs: () => I18n.siteCountryLs,
    freeShippingAmount: () => humanizePrice(vueSupport.common.freeShippingAmount, { precision: 0 }),
    countryCode: () => vueSupport.countryCode,
    webCountry () {
      return this.$t('country', this.i18nSiteCountryLs)
    },
    userCountry () {
      return this.$t('country', this.countryCode.toLowerCase())
    },
    companyLocaleText () {
      return `${this.$t('meta.company')} ${this.webCountry}`
    },
    countrySpecificText () {
      return {
        minFreeShipping: ['ph', 'hk'],
        exclusive: ['ph', 'hk', 'nz'],
        freeSamples: ['ph', 'hk']
      }
    },
    showGDPR () {
      if (getFromSession('gdpr')) {
        return false
      }
      return europeanUnion.includes(this.countryCode)
    },
    showWelcomeMat () {
      // to enable when welcome mat is moved to vue
      // return this.$te('country', this.countryCode) || this.showGDPR
      return this.showGDPR
    }
  },

  mounted () {
    $(this.$refs.welcomeMat).modal('show')
    saveToSession('gdpr', true)
  }
}
</script>

<style scoped lang='scss'>
  .close-location-info {
    margin-top: 0;
    margin-right: 0;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 2;
  }

  .location-info-popup {
    .location-info-modal-stripes {
      background-image: url('../../assets/images/icons/black-lines-triangle.svg');
      background-repeat: no-repeat;
      height: 84px;

      &.bottom-stripe {
        transform: rotate(180deg);
      }
    }

    .page-title {
      margin-top: 0;

      @include media-breakpoint-down(sm) {
        margin-top: 10px;
        font-size: 32px;
      }
    }

    .modal-header {
      padding: 0;
    }

    .modal-body {
      text-align: center;
      padding-top: 10px;

      @include media-breakpoint-down(sm) {
        padding: 20px;
      }
    }

    .location-info-welcome {
      @include font-weight-bold;
      margin-right: 10px;

      @include media-breakpoint-up(sm) {
        display: inline;
      }
    }

    .location-info-brief {
      @include font-weight-book;
      line-height: 24px;
      margin-bottom: 30px;
      margin-top: 30px;

      @include media-breakpoint-down(sm) {
        font-size: 20px;
      }
    }

    .location-info-promotions {
      font-size: 13px;

      @include media-breakpoint-up(md) {
        font-size: 14px;
      }

      &::before {
        content: '';
        background: url('../../assets/images/tick-mark.png');
        background-repeat: no-repeat;
        background-size: 10px 10px;
        width: 15px;
        height: 10px;
        display: inline-block;
      }
    }

    .location-info-start-shopping,
    .location-info-not-shipping-europe {
      margin-top: 20px;
      margin-bottom: 30px;

      @include media-breakpoint-down(sm) {
        font-size: 13px;
        margin-left: 45px;
        margin-right: 45px;
      }
    }

    .location-info-not-shipping,
    .location-info-continue-browsing {
      span {
        margin-right: 5px;
      }
    }

    .location-info-redirect-link {
      text-decoration: underline;
    }
  }

  .location-find-store {
    margin-left: 5px;
  }
</style>
